<template>
<ul class="info-ul" :class="{'setting': setFlag}">
    <li v-if='!setFlag'>
        <span class="info-pos-pic"></span>
        <span class="info-pic-title">{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
    </li>
    <li v-else>
        <span class="info-set-pic"></span>
        <span class="info-pic-title">{{$t('T_RESULT_PROJECTOR_SETTING')}}</span>
    </li>
    <li v-for="(item, index) in arrayData" :key="index">
        <span v-show="!setFlag">{{'(' + (index + 1) + ')'}}</span>
        <span>{{$t(item.title)}}</span>
        <span :class="item.isNegativeNum ? 'negative_num_color' : ''">{{item.value}}</span>
    </li>
</ul>
</template>

<script>
export default {
  name: 'infoListPanel',
  props: ['setFlag', 'arrayData'],
  data () {
    return {
    }
  },

  mounted () {
  },

  methods: {
  },

  components: {}
}
</script>

<style scoped>
.info-ul {
    width: 100%;
    padding-left: 20px;
    font-size: 16px;
    line-height: 1.3;
}

.info-ul li:first-child {
    font-weight: bold;
    padding-bottom: 10px;
    display: flex;
}

.info-pic-title {
    line-height: 36px;
    padding-left: 10px;
}

.info-pos-pic, .info-set-pic {
    display: inline-table;
    width: 36px;
    height: 36px;
}

.info-pos-pic {
    background: url('../assets/parts/report/position.png') no-repeat;
    background-size: contain;
}

.info-set-pic {
    background: url('../assets/parts/report/setting.png') no-repeat;
    background-size: contain;
}

.setting li {
  list-style: disc;
  margin-left: 10px;
}

.setting li:first-child {
  list-style: none;
  margin-left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/infoListPanel.vue